import Model from 'flarum/common/Model';
export default class CreatorDeclaration extends Model {
  key = (() => Model.attribute('key'))();
  source = (() => Model.attribute('source'))();
  metadata = (() => Model.attribute('metadata'))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
}
flarum.reg.add('ffans-creator-declarations', 'common/models/CreatorDeclaration', CreatorDeclaration);